import { Box, Stack, Typography } from '@mui/material';

import { radius } from '@karehero/llama/theme/radius';

import StatusBar from '@/designs-dev/device/StatusBar';
import HomeIndicator from '@/designs-dev/device/HomeIndicator';
import ScreenRoot from '@/components/wrapped/ScreenRoot';
import { ELIGIBLE } from '@/karehero-app/tell-us-once/intake/content';

// The other side of the calculator: it has run, and this is what it found. Also
// a hole drawn as one, and a copy of CalculatorScreen rather than a shared
// placeholder, so either can be designed without disturbing the other.
//
// It exists because the calculator handing straight to a review skipped the
// moment the whole flow is for: the claim is worth doing.
const EligibleScreen = ({ onNext }: { onNext: () => void }) => (
  <ScreenRoot sx={{ bgcolor: 'custom.neutral.300' }}>
    <StatusBar />

    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
      }}
    >
      <Stack
        onClick={onNext}
        sx={{
          width: '100%',
          p: 3,
          textAlign: 'center',
          border: 1,
          borderStyle: 'dashed',
          borderColor: 'custom.neutral.500',
          borderRadius: `${radius.md}px`,
          cursor: 'pointer',
        }}
        spacing={1}
      >
        <Typography sx={{ color: 'text.secondary' }} variant='overline'>
          Placeholder
        </Typography>
        <Typography variant='h2'>{ELIGIBLE.title}</Typography>
        <Typography sx={{ color: 'text.secondary' }} variant='body2'>
          {ELIGIBLE.note}
        </Typography>
      </Stack>
    </Box>

    <HomeIndicator />
  </ScreenRoot>
);

export default EligibleScreen;
